<template>
    <div class="d-flex justify-center animation-opacity">
        <div>
            <h1 class="app-title">
            {{smsLoaderData}}</h1>
            <div class="text-center mt-1">
                <v-progress-circular
                    :size="30"
                    class="color-icon"
                    :width="7"
                    indeterminate
                ></v-progress-circular>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        smsLoaderData: String
    }
}
</script>